import FruitCard from "../../layouts/FruitCard";
import bg from "/cywe-assets/card/red.png";
import fruit from "/cywe-assets/fruit/strawberry.png";

export default function Red({
	setValue,
	value,
}: {
	setValue: (value: number) => void;
	value: number;
}) {
	return (
		<>
			<FruitCard
				title="God is Love!"
				description="Love is when you are able to care, more than you ever thought was possible. When you forgive someone, even without them explaining themself. Love is when you enjoy someone’s presence and wish that moment would last forever. We’re not talking about romantic love. But a heart-to-heart connection, loving your mom, children, grandma, cousin, friend, or even someone you met by chance. And even though you only got to spend a short time with him or her, the encounter impacted you greatly and made the time spent a blessing. Because what was exchanged was memorable and had a lasting effect."
				bg={bg}
				fruit={fruit}
				setValue={setValue}
				value={value}
				next="/experience/2"
			/>
		</>
	);
}
